import { render, staticRenderFns } from "./CLCHomePage.vue?vue&type=template&id=3bd77d31"
import script from "./CLCHomePage.vue?vue&type=script&lang=js"
export * from "./CLCHomePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports